import React from 'react';
import { useField, connect } from 'formik';
import styled from 'styled-components';

import FieldContextFeeder from '../components/FieldContextFeeder';
import Urgency from '../components/Urgency';

const idToOption = (id, options) => {
  return options?.find(option => option.value === id);
};

const optionToId = option => {
  return option.value;
};

const UrgencyIdField = props => {
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;
  const { setFieldValue } = props.formik;

  const name = props.id || props.name;

  const localProps = {
    ...field,
    ...props,
    error,
    value: idToOption(field.value, props.options),
    // https://github.com/formium/formik/issues/789
    onChange: option => {
      const id = optionToId(option);
      setFieldValue(name, id);
      if (props.onChange) props.onChange(id);
    },
  };

  return (
    <Container className={props.className}>
      <Urgency {...localProps} />
    </Container>
  );
};

const Container = styled.div`
  max-width: var(--field-width);
`;

export default FieldContextFeeder(connect(UrgencyIdField));
